export const getUpgradeModalIdentifier = ({ sharedReducer: { upgradeModalIdentifier } }) =>
	upgradeModalIdentifier;
